import {BrowserOptions} from "@sentry/react";

export const configOptions: BrowserOptions = {
  enabled: import.meta.env.VITE_SENTRY_AUTH_TOKEN !== undefined,
  dsn: "https://649558294e59a7a259f9b8c9a2f718ce@o253791.ingest.us.sentry.io/4506916022321152",
  environment: import.meta.env.VITE_ENVIRONMENT || "local",
  release: import.meta.env.VITE_SENTRY_RELEASE || "local",
  ignoreErrors: ["unauthorized"],
  // HubSpot tracking script proxied through GTM at /analytics/<timestamp>/<portal-id>.js
  denyUrls: [/\/analytics\/\d+\/\d+\.js/],
};
